import React from 'react';
import RecommendedModelCard from './RecommendedModelCard';

function RecommendedModelsGrid({ models, onCardClick }) {
  if (!models || models.length === 0) {
    return (
      <div className="desktop-models-grid-empty">
        <div className="desktop-empty-icon">
          <i className="fa-solid fa-search" />
        </div>
        <h3>No Recommended Models</h3>
        <p>Discover will populate once recommendations are available.</p>
      </div>
    );
  }

  return (
    <div className="desktop-models-grid">
      {models.map((m) => (
        <RecommendedModelCard key={m.displayName} model={m} onCardClick={onCardClick} />
      ))}
    </div>
  );
}

export default RecommendedModelsGrid;

